import { Injectable, Component, Inject, HostListener, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { DOCUMENT, Location } from '@angular/common';
import { ActivatedRoute, Event } from '@angular/router';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as Rx from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { AppService, AppSettingService, AppUtilityService } from '../../app.service';
import { UserInfoService } from '../user-info.service';
import { UserAPIService, SessionAPIService } from '../user-api.service';
import { ZoneAPIService } from '../../zone/zone-api.service';
import { DOBService } from '../../utility/utility.service';
import { InstitutionAPIService } from '../../institution/institution-api.service';

export type TSignupLoginType = "signup" | "login" | "reset" | "globallogin" | "globalsignup" ;
export type TSignupLoginResult = "cancel" | "signup" | "login" | "reset" | "globallogin" | "globalsignup" | "showLogin" | "showSignup" | "showReset";

@Injectable({
	providedIn: 'root'
})
export class SignupLoginService {
	get askedGlobalAccount(): boolean {
		return (sessionStorage.getItem('askedGlobalAccount') ?? "").toLowerCase() === "true" ? true : false;
	}

	set askedGlobalAccount(v: boolean) {
		if (v == null) {
			sessionStorage.removeItem("askedGlobalAccount");
		}
		else {
			sessionStorage.setItem('askedGlobalAccount', String(v));
		}
	}

	get userDefaultZone(): string {
		return localStorage.getItem('userDefaultZone') ?? "";
	}

	set userDefaultZone(v: string) {
		localStorage.setItem('userDefaultZone', String(v));
	}

	get promptGlobalAccountIntro(): "login" | "signup" | null {
		let xx: string =  localStorage.getItem('promptGlobalAccountIntro');
		return  xx== null? null: xx === "login"? "login": "signup";
	}

	set promptGlobalAccountIntro(v: "login"|"signup") {
		if (v == null) {
			localStorage.removeItem("promptGlobalAccountIntro");
		}
		else {
			localStorage.setItem('promptGlobalAccountIntro', String(v));
		}
	}
}


/* Login standalone Page */
@Component({
	template: `<app-signup-login *ngIf="isReady" [display]="display" [prefillUsername]="prefillUsername" [allowCancel]="allowCancel" (onCloseSL)="closeSL($event)"></app-signup-login>`,
	standalone: false
})
export class LoginControl  {
	isReady: boolean = false;
	display: TSignupLoginType = "login";
	allowCancel:boolean = false;
	prefillUsername: string = "";

	constructor(
		private userInfo: UserInfoService,
		private sessionAPI: SessionAPIService,
		private location: Location,
		private route: ActivatedRoute
	) {}

	closeSL(action: TSignupLoginResult): void {
		//put any that need to be after close
	}

	ngOnInit(): void {
		//hide prefillUsername
		this.prefillUsername = (this.route.snapshot.paramMap.get("prefillUsername")??"").trim();
		if (this.prefillUsername !== "") {
			this.location.replaceState("/User/Login");
		}
		if (this.userInfo.isLogin() && !this.userInfo.isAnonymous()) {
			this.sessionAPI.anonymous().subscribe({
				next: () => {
					this.isReady = true;
				},
				error: (err: any) => {
					console.log(err);
				}
			});
		}
		else {
			this.isReady = true;
		}
	}
}


/* Reset password standalone Page */
@Component({
	template: `<app-signup-login *ngIf="isReady" [display]="display" [resetCode]="resetCode" [allowCancel]="allowCancel" (onCloseSL)="closeSL($event)"></app-signup-login>`,
	standalone: false
})
export class ResetPasswordControl {
	isReady: boolean = false;
	display: TSignupLoginType = "reset";
	allowCancel: boolean = false;
	resetCode: string = "";

	constructor(
		private userInfo: UserInfoService,
		private sessionAPI: SessionAPIService,
		private location: Location,
		private route: ActivatedRoute
	) { }

	closeSL(action: TSignupLoginResult): void {
		//put any that need to be after close
	}

	ngOnInit(): void {
		//if user pass anonymousUserLink, hide it from url and not reload the page
		this.resetCode = (this.route.snapshot.paramMap.get("resetCode") ?? "").trim();
		if (this.resetCode !== '') {
			this.location.replaceState("/User/ResetPassword");
		}
		if (this.userInfo.isLogin() && !this.userInfo.isAnonymous()) {
			this.sessionAPI.anonymous().subscribe({
				next: () => {
					this.isReady = true;
				},
				error: (err: any) => {
					console.log(err);
				}
			});
		}
		else {
			this.isReady = true;
		}
	}
}


/* Sign up standalone Page */
@Component({
	template: `<app-signup-login *ngIf="isReady" [display]="display" [anonymousUserLink]="anonymousUserLink" [allowCancel]="allowCancel" (onCloseSL)="closeSL($event)"></app-signup-login>`,
	standalone: false
})
export class SignupControl {
	isReady: boolean = false;
	display: TSignupLoginType = "signup";
	allowCancel: boolean = false;
	anonymousUserLink: string = "";

	constructor(
		private userInfo: UserInfoService,
		private sessionAPI: SessionAPIService,
		private location: Location,
		private route: ActivatedRoute
	) { }

	closeSL(action: TSignupLoginResult): void {
		//put any that need to be after close
	}

	ngOnInit(): void {
		//if user pass anonymousUserLink, hide it from url and not reload the page
		this.anonymousUserLink = (this.route.snapshot.paramMap.get("anonymousUserLink") ?? "").trim();
		if (this.anonymousUserLink !== '') {
			this.location.replaceState("/User/Signup");
		}
		if (this.userInfo.isLogin() && !this.userInfo.isAnonymous()) {
			this.sessionAPI.anonymous().subscribe({
				next: () => {
					this.isReady = true;
				},
				error: (error: any) => {
					console.log(error);
				}
			});
		}
		else {
			this.isReady = true;
		}
	}
}


@Component({
	template: `
		<div style="margin:0px; padding:0px; width:100%; height:100%; position:absolute;">
			<div *ngIf="!isReady" style="height:110%; width:100%; z-index:9999; position:absolute; background-color:#fff; margin-top:-30px; display:flex; justify-content:center; align-items:center;"></div>
			<app-signup-login *ngIf="isReady" [display]="display" [allowCancel]="allowCancel" [prefillUsername]="prefillUsername" [globalAccount]="globalAccount" [goHome]="goHome" (onCloseSL)="closeSL($event)"></app-signup-login>
		</div>`,
	standalone: false
})
export class SignupLoginDialog {
	isReady: boolean = false;
	allowCancel: boolean = true;
	display: TSignupLoginType = 'login';
	prefillUsername: string = "";
	globalAccount: boolean = false;
	goHome: boolean = true; // send user to the home page or not
	
	constructor(
		private dialogRef: MatDialogRef<SignupLoginDialog>,
		@Inject(MAT_DIALOG_DATA) private data: any
	) {
		this.allowCancel = data.allowCancel ?? true;
		this.display = data.display ?? "login";
		this.prefillUsername = data.prefillUsername ?? "";
		this.globalAccount = data.globalAccount ?? false;
		this.goHome = data.goHome ?? true;
	}

	closeSL(action: TSignupLoginResult): void {
		this.dialogRef.close(action);
	}

	ngOnInit(): void {
		this.prefillUsername = (this.prefillUsername ?? "").trim();
		this.isReady = true;
	}
}


/* sign up, login, reset password components */
@Component({
	selector: 'app-signup-login',
	templateUrl: './signup-login.component.html',
	styleUrls: ["./login.scss"],
	standalone: false
})
export class SignupLoginComponent {
	@Input() display: TSignupLoginType = "login";
	@Input() allowCancel: boolean = true;
	@Input() resetCode: string = ""
	@Input() prefillUsername: string = "";
	@Input() globalAccount: boolean = false;
	@Input() anonymousUserLink: string = "";
	@Input() goHome: boolean = true;
	@Output() onCloseSL: EventEmitter<TSignupLoginResult> = new EventEmitter();

	@ViewChild("SignupComponent") signupComponent: SignupComponent;
	@ViewChild("ResetPasswordComponent") resetPasswordComponent: ResetPasswordComponent;

	constructor(
		private appSrv: AppService,
		private location: Location,
		private signupLoginSrv: SignupLoginService,
		private userInfo: UserInfoService,
		private zoneAPI: ZoneAPIService
	) {}

	loadType: TSignupLoginType = this.display;
	userZone: any = null;
	isPublic: boolean = true;
	loadingWidget: boolean = true;

	showMinimize = AppSettingService.widgetMobile();

	windowInnerHeight: string = window.innerHeight - 1 + 'px'; //-1 because scroll bar otherwise

	@HostListener('window:resize', ['$event']) onResize(e: Event) {
		this.showMinimize = AppSettingService.widgetMobile();
	}

	// change path if it is login, signup, resetpassword
	private changePath: boolean = false;

	// signup, resetpassword use changePathNotReload in controller 
	// this function is used to call back, so either use bind to force "this" is itself or use "=>"
	closeSL = (action: TSignupLoginResult) => {
		if (action === 'showReset') {
			if (this.changePath) {
				this.appSrv.redirectReload("/User/ResetPassword");
			}
			else {
				this.loadType = 'reset';
			}
		}
		else if (action === 'showLogin') {
			if (this.changePath) {
				this.appSrv.redirectReload("/User/Login");
			}
			else {
				this.loadType = this.globalAccount ? 'globallogin' : 'login';
			}
		}
		else if (action === 'showSignup') {
			if (this.changePath) {
				this.appSrv.redirectReload("/User/Signup");
			}
			else {
				this.loadType = this.globalAccount ? 'globalsignup' : 'signup';
			}
		}
		else {
			if (this.goHome) {
				if (action === "signup" || action === "login") {
					this.signupLoginSrv.askedGlobalAccount = null;
					if (this.globalAccount) {
						// need to prompt users "You have successfully created your Journeys Map Global Account. ..."
						this.signupLoginSrv.promptGlobalAccountIntro = action;
					}
					if (!this.userInfo.isJAZone() && this.userInfo.getProfile().HighestRole.toLowerCase() === 'student' || this.userInfo.getProfile().HighestRole.toLowerCase() === 'other') {
						window.location.href = AppSettingService.baseUrl + "/User/CheckMyProgress?tm=" + AppUtilityService.newId();
					}
					else {
						window.location.href = this.userInfo.getHomePage() + ((this.userInfo.getHomePage().indexOf("?") > 0) ? "&" : "?") + "tm=" + AppUtilityService.newId();
					}
				}
			}
			this.onCloseSL.emit(action);
		}
	}

	ngOnInit(): void {
		if (this.globalAccount && this.display === "reset") {
			console.debug("Cannot Rreset Password for global account link");
			this.closeSL("cancel");
		}

		this.prefillUsername = (this.prefillUsername ?? "").trim();
		this.anonymousUserLink = (this.anonymousUserLink ?? "").trim();
		this.resetCode = (this.resetCode ?? "").trim();

		if (this.userInfo.isAnonymous() === false && this.display === 'signup') {
			this.display = 'login';
		}

		let currentPath = this.location.path().toLowerCase();
		if (currentPath.indexOf('/user/login') === 0 || currentPath.indexOf('/user/signup') === 0 || currentPath.indexOf('/user/resetpassword') === 0) {
			this.changePath = true;
		}

		this.zoneAPI.getUserZone().subscribe({
			next: (response: any) => {
				this.loadingWidget = false;
				this.userZone = response;
				this.isPublic = this.userZone.IsPublic;
				// if the zone not allow to sign up, force user to login instead
				if (this.userZone.AllowSignup == false && this.display === 'signup') {
					this.display = 'login';
				}
				this.loadType = this.display;
			},
			error: (error: any) => {
				console.log(error);
				this.loadingWidget = false;
				this.loadType = 'login';
			}
		});		
	}
}

export type UserZone = {
	Client: string,
	DisplayName: string
};

@Component({
	selector: "app-login",
	templateUrl: "./login.component.html",
	styleUrls: ["./login.scss"],
	standalone: false
})
export class LoginComponent {
	@Input() allowCancel: boolean = false;
	@Input() prefillUsername: string = "";
	@Input() onClose: Function = null;

	constructor(
		private sessionAPI: SessionAPIService,
		private signupLoginSrv: SignupLoginService,
		private userAPI: UserAPIService
	) { }

	frmLogin: {
		username: string,
		usernameStatus?: boolean,
		password: string,
		passwordStatus?: boolean,
		myZone: string,
		zonesUpdating: boolean,
		zones?: UserZone[]
	} = {
		username: "",
		usernameStatus: null,
		password: "",
		passwordStatus: null,
		myZone: "",
		zonesUpdating: false,
		zones: []
	};

	msg: string = "";
	isLogging: boolean = false;
	showMinimize = AppSettingService.widgetMobile();

	@HostListener('window:resize', ['$event']) onResize(e: Event) {
		this.showMinimize = AppSettingService.widgetMobile();
	}

	//#region username
	@ViewChild('txtU') txtUsername: ElementRef;
	@ViewChild('selZ') selZone: ElementRef;

	private searchZone$ = new Rx.Subject<string>();
	lookupZone(e: any): void {
		this.searchZone$.next(this.frmLogin.username);
	}

	private searchZones() {
		this.frmLogin.zonesUpdating = true;
		this.frmLogin.zones = [];
		if (this.frmLogin.username.length < 1) {
			this.frmLogin.zonesUpdating = false;
			return;
		}
		this.userAPI.checkUserNameExist(this.frmLogin.username, "").subscribe({
			next: (response: any) => {
				if (response.Zones.length > 0) {
					let defaultZone: UserZone = response.Zones.find((x: any) => this.signupLoginSrv.userDefaultZone !== "" && x.Client === this.signupLoginSrv.userDefaultZone);
					if (defaultZone !== undefined && defaultZone !== null) {
						this.frmLogin.myZone = this.signupLoginSrv.userDefaultZone;
					}
					else {
						this.frmLogin.myZone = response.Zones[0].Client;
					}
					this.frmLogin.usernameStatus = true;
				}
				else {
					this.frmLogin.myZone = "";
					this.frmLogin.usernameStatus = false;
				}
				this.frmLogin.zones = response.Zones;
				this.frmLogin.zonesUpdating = false;
			},
			error: (err: any) => {
				console.log(err);
				this.frmLogin.zonesUpdating = false;
				this.frmLogin.myZone = "";
				this.frmLogin.usernameStatus = null;
				this.frmLogin.zones = [];
			}
		});
	}

	changeZone(e: any) {
		if (this.frmLogin.zones.length === 0) {
			this.frmLogin.myZone = "";
		}
		else {
			this.frmLogin.myZone = this.selZone.nativeElement.value;
		}
	}
	//#endregion username

	//#region password
	@ViewChild('txtP') txtPassword: ElementRef;

	txtPwType: string = 'password';	
	showPassword(enforce: string) {
		this.txtPassword.nativeElement.type = this.txtPassword.nativeElement.type === 'password' ? 'text' : 'password';
		if (enforce != null) {
			this.txtPassword.nativeElement.type = enforce;
			this.txtPwType = enforce;
		}
	}
	//#endregion password

	//#region perform login
	private doLogin() {
		this.isLogging = true;
		if (this.canLogin()) {
			this.sessionAPI.signOn(this.frmLogin.username, this.frmLogin.password, this.frmLogin.myZone).subscribe({
				next: () => {
					this.signupLoginSrv.userDefaultZone = this.frmLogin.myZone;
					this.onClose('login');
				},
				error: (error: any) => {
					console.log(error);
					let err = error.error;
					this.isLogging = false;
					this.frmLogin.passwordStatus = false;
					if (err != null && err.Code != null && err.Code === '70000') {
						this.msg = 'Unable to verify account, please contact <a href="mailto:help@journeysmap.com">help@journeysmap.com</a>.';
					}
					else {
						this.msg = 'Uh oh. Something isn\'t quite right. Please try again.';
					}
				}
			});
		}
		else {
			this.isLogging = false;
			this.msg = 'Uh oh. All fields are required.';
		}
	}

	canLogin() {
		if (!this.frmLogin.zonesUpdating && this.frmLogin.username.trim() !== '' && this.frmLogin.password.trim() !== '' && this.frmLogin.myZone.trim() !== "") {
			return true;
		}
		else {
			return false;
		}
	}

	submitLogin(e: any, nextStep: boolean) {
		if (e == null) {
			return;
		}
		if (e.type === 'keydown' && e.keyCode !== 13 && e.keyCode !== 9) {
			this.msg = '';
			return;
		}
		if (this.canLogin() && (e.keyCode === 13 || nextStep != null)) {
			this.doLogin();
		}
	}
	//#endregion perform login

	//#region UI switch
	resetPassword(e: any) {
		e.preventDefault();
		this.onClose('showReset');
	}

	createAccount(e: any) {
		e.preventDefault();
		this.onClose('showSignup');
	}

	cancel(e: any): void {
		e.preventDefault();
		this.onClose('cancel');
	}
	//#endregion UI switch

	ngOnDestroy() {
		this.searchZone$.unsubscribe();
	}

	ngAfterViewInit(): void {
		this.frmLogin.username = this.prefillUsername = (this.prefillUsername ?? "").trim();
		setTimeout(() => {
			try { this.txtUsername.nativeElement.focus(); }
			catch (ex) { ; }
		}, 500);
	}

	ngOnInit() {
		this.searchZone$.pipe(
			debounceTime(300),
			distinctUntilChanged()
		).subscribe((kw: string) => {
			if (kw.trim().length < 1) {
				this.frmLogin.zones = [];
			}
			else {
				this.searchZones();
			}
		});
	}
}


@Component({
	selector: "app-reset-password",
	templateUrl: "./reset-password.component.html",
	styleUrls: ["./login.scss"],
	standalone: false
})
export class ResetPasswordComponent {
	@Input() allowCancel: boolean = false;
	@Input() resetCode: string = "";
	@Input() onClose: Function = null;

	constructor(
		@Inject(DOCUMENT) private doc: any,
		private userAPI: UserAPIService,
		private sessionAPI: SessionAPIService
	) { }

	processing:boolean = false;
	currentStep?: number = null;
	resetPWResponse:any = null;

	steps = [
		'username',
		'resetOption',
		'securityQuestion',
		'newPassword',
		'emailSent',
		'error',
		'resetCode'
	];

	frmReset: {
		UsernameOrEmail: string,
		UsernameOrEmailStatus?: boolean,
		RecoveryOption: string,
		SecurityQuestion: string,
		SecurityAnswer: string,
		SecurityStatus?: boolean,
		NewPassword: string,
		NewPasswordStatus?: boolean,
		NewPassword2: string,
		NewPassword2Status?: boolean,
		ResetCode: string,
		ResetCodeStatus?: boolean,
		Zone: string,
		zonesUpdating: boolean,
		zones?: UserZone[]
	} = {
		UsernameOrEmail: '',
		UsernameOrEmailStatus: null,
		RecoveryOption: '',
		SecurityQuestion: '',
		SecurityAnswer: '',
		SecurityStatus: null,
		NewPassword: '',
		NewPasswordStatus: null,
		NewPassword2: '',
		NewPassword2Status: null,
		ResetCode: '',
		ResetCodeStatus: null,
		Zone: "",
		zonesUpdating: false,
		zones: []
	};

	//#region username
	@ViewChild('txtUsername') txtUsername: ElementRef;
	@ViewChild('selZone') selZone: ElementRef;
	@ViewChild('btnUsernameNext') btnUsernameNext: ElementRef;

	showMinimize = AppSettingService.widgetMobile();

	@HostListener('window:resize', ['$event']) onResize(e: Event) {
		this.showMinimize = AppSettingService.widgetMobile();
	}

	hasUsername(): boolean {
		if (!this.frmReset.zonesUpdating && this.frmReset.UsernameOrEmail.trim() !== '' && this.frmReset.Zone.trim() !== "") {
			return true;
		}
		else {
			return false;
		}
	}

	private populateZones() {
		this.frmReset.zonesUpdating = true;
		this.userAPI.checkUserNameExist(this.frmReset.UsernameOrEmail, "").subscribe({
			next: (response: any) => {
				this.frmReset.zonesUpdating = false;
				if (response.Zones.length > 0) {
					this.frmReset.Zone = response.Zones[0].Client;
					this.frmReset.UsernameOrEmailStatus = true;
				}
				else {
					this.frmReset.Zone = "";
					this.frmReset.UsernameOrEmailStatus = false;
				}
				this.frmReset.zones = response.Zones;
			},
			error: (err: any) => {
				console.log(err);
				this.frmReset.zonesUpdating = false;
				this.frmReset.Zone = "";
				this.frmReset.UsernameOrEmailStatus = null;
				this.frmReset.zones = [];
			}
		});
	}

	changeZone(e: any) {
		if (this.frmReset.zones.length === 0) {
			this.frmReset.Zone = "";
		}
		else {
			this.frmReset.Zone = this.selZone.nativeElement.value;
		}
	}

	checkUsername(e: any): void {
		if (e == null) {
			return;
		}
		if (e.type === 'keydown' && e.keyCode !== 13 && e.keyCode !== 9) {
			return;
		}

		if (this.frmReset.UsernameOrEmail.trim().length > 0) {
			if (	(e.type === 'keydown' && (e.keyCode === 13 || e.keyCode === 9)) ||
					(e.type == 'blur' && e.currentTarget.id === this.txtUsername.nativeElement.id)
			)
			{
				this.selZone.nativeElement.focus();
				this.populateZones();
			}
		}

		if (e.currentTarget.id === this.btnUsernameNext.nativeElement.id) {
			if (this.hasUsername()) {
				this.checkOption();
			}
		}
	}
	//#endregion username

	//#region resetOption
	doOption(e: any, option: string) {
		if (option === 'email') {
			this.sendEmail();
		}
		else {
			this.askSecurityQuestion();
		}
	}

	private askOption(): void {
		this.currentStep = 1;
		this.processing = false;
	}

	private checkOption(): void {
		this.processing = true;
		this.resetPWResponse = null;
		this.userAPI.resetPassword(this.frmReset).subscribe({
			next: (response: any) => {
				this.resetPWResponse = response;
				if (this.resetPWResponse.RecoveryStatusCode === '10') {
					if (this.resetPWResponse.IsEmail && this.resetPWResponse.SecurityQuestion !== '') {
						this.askOption();
					}
					else if (this.resetPWResponse.SecurityQuestion !== '') {
						this.askSecurityQuestion();
					}
					else if (this.resetPWResponse.IsEmail) {
						this.sendEmail();
					}
					else {
						this.displayError();
					}
				}
				else {
					this.displayError();
				}
			},
			error: (error: any) => {
				console.log(error);
				this.displayError();
			}
		});
	}
	//#endregion resetOption

	//#region securityQuestion
	checkSecurityAnswer(e: any): void {
		if (this.processing === true || e == null || (e.type !== 'click' && e.keyCode !== 13) || this.frmReset.SecurityAnswer === '') {
			return;
		}
		this.processing = true;
		this.resetPWResponse = null;
		this.userAPI.resetPassword(this.frmReset).subscribe({
			next: (response: any) => {
				this.resetPWResponse = response;
				if (this.resetPWResponse.RecoveryStatusCode === '11') {
					this.frmReset.SecurityStatus = true;
					this.askNewPassword();
				}
				else {
					this.processing = false;
					this.frmReset.SecurityStatus = false;
				}
			},
			error: (error: any) => {
				console.log(error);
				this.processing = false;
			}
		});
	}

	private askSecurityQuestion(): void {
		this.currentStep = 2;
		this.processing = false;
		this.frmReset.RecoveryOption = 'question';
		this.frmReset.SecurityQuestion = this.resetPWResponse.SecurityQuestion;
	}
	//#endregion securityQuestion

	//#region newPassword
	txtNewPasswordIsFocused: boolean = false;
	checkNewPassword(e: any): void {
		if (!this.processing && e.type === 'focus' && e.target.id === 'txtNewPassword') {
			this.txtNewPasswordIsFocused = true;
		}
		if (!this.processing && e.type === 'blur' && e.target.id === 'txtNewPassword') {
			this.txtNewPasswordIsFocused = false;
		}

		if (this.processing === true || e == null || (e.type !== 'click' && e.keyCode !== 13)) {
			return;
		}

		var pw = AppUtilityService.validatePassword(this.frmReset.NewPassword);
		this.frmReset.NewPasswordStatus = pw.strength < 100 ? false : true;
		pw = AppUtilityService.validatePassword(this.frmReset.NewPassword2);
		this.frmReset.NewPassword2Status = pw.strength < 100 ? false : true;

		if (this.frmReset.NewPassword === '' || this.frmReset.NewPasswordStatus === false || (this.frmReset.NewPassword !== this.frmReset.NewPassword2)) {
			return;
		}

		this.processing = true;
		this.resetPWResponse = null
		this.userAPI.resetPassword(this.frmReset).subscribe({
			next: (response: any) => {
				this.resetPWResponse = response;
				if (this.resetPWResponse.RecoveryStatusCode === '0') {
					//perform login
					this.frmReset.Zone = response.Zone;
					this.sessionAPI.signOn(this.resetPWResponse.Username, this.frmReset.NewPassword, this.frmReset.Zone).subscribe({
						next: () => {
							this.processing = false;
							this.onClose('login');
						},
						error: (error: any) => {
							console.log(error);
							this.processing = false;
						}
					});
				}
				else {
					this.processing = false;
					return;
				}
			},
			error: (error: any) => {
				console.log(error);
				this.displayError();
			}
		});
	}

	txtPw1Type: string = 'password';
	txtPw2Type: string = 'password';	
	showPassword(id: any): void {
		var pw = this.doc.getElementById(id);
		if (pw != null) {
			pw.type = pw.type === 'password' ? 'text' : 'password';
			if (id === 'txtNewPassword') {
				this.txtPw1Type = pw.type;
			}
			if (id === 'txtNewPassword2') {
				this.txtPw2Type = pw.type;
			}
		}
	}

	private askNewPassword(): void {
		this.currentStep = 3;
		this.processing = false;
	}
	//#endregion newPassword

	//#region emailSent
	private sendEmail(): void {
		this.resetPWResponse = null;
		this.processing = true;
		this.frmReset.RecoveryOption = 'email';
		this.userAPI.resetPassword(this.frmReset).subscribe({
			next: (response: any) => {
				this.resetPWResponse = response;
				if (this.resetPWResponse.RecoveryStatusCode === '9') {
					this.currentStep = 4;
					this.processing = false;
				}
				else {
					this.currentStep = 5;
					this.processing = false;
				}
			},
			error: (error: any) => {
				console.log(error);
				this.currentStep = 5;
				this.processing = false;
			}
		});
	}
	//#endregion emailSent

	//#region resetCode
	private checkResetCode() {
		this.currentStep = 6;
		this.processing = true;
		this.resetPWResponse = null;
		this.frmReset.ResetCode = this.resetCode;
		this.userAPI.resetPassword(this.frmReset).subscribe({
			next: (response: any) => {
				this.resetPWResponse = response;
				if (this.resetPWResponse.RecoveryStatusCode === '11') {
					this.frmReset.ResetCodeStatus = true;
					this.frmReset.Zone = response.Zone;
					this.askNewPassword();
				}
				else {
					this.processing = false;
					this.frmReset.ResetCodeStatus = false;
				}

			},
			error: (error: any) => {
				console.log(error);
			}
		});
	}
	//#endregion resetCode

	//#region error
	private displayError(): void {
		this.currentStep = 5;
		this.processing = false;
	}
	//#endregion error

	//#region UI switch
	cancel(e: any) {
		e.preventDefault();
		this.onClose('showLogin');
	}

	backToLogin(e: any): void {
		e.preventDefault();
		this.onClose('showLogin');
	}

	backToSignup(e: any): void {
		e.preventDefault();
		this.onClose('showSignup');
	}

	backToReset(e: any): void {
		e.preventDefault();
		this.onClose('showReset');
	}
	//#endregion UI switch

	ngOnDestroy() {
	}

	ngAfterViewInit(): void {
		setTimeout(() => {
			try { this.txtUsername.nativeElement.focus(); }
			catch (ex) { ; }
		}, 500);
	}

	ngOnInit(): void {
		// if resetcode is provided?
		if (this.resetCode !== '') {
			this.checkResetCode();
		}
		else {
			this.currentStep = 0;
		}
	}
}


@Component({
	selector: "app-signup",
	templateUrl: "./signup.component.html",
	styleUrls: ["./login.scss"],
	standalone: false
})
export class SignupComponent  {
	@Input() isPublic: boolean = true;
	@Input() allowCancel: boolean = false;
	@Input() anonymousUserLink: string = "";
	@Input() onClose: Function = null;

	constructor(
		@Inject(DOCUMENT) private doc: any,
		private sessionAPI: SessionAPIService,
		private userInfo: UserInfoService,
		private userAPI: UserAPIService,
		private dobSrv: DOBService,
		private institutionAPI: InstitutionAPIService
	) { }

	minAge: number = 13;
	private nameMinLen: number = 2;
	private usernameMinLen: number = 4;
	maxYear: number = (new Date()).getFullYear();
	minYear: number = this.maxYear - 100;
	private institution: any = null;
	private anonymousUser: any = null;
	iStepHighestReached: number = 0;
	isWaiting: boolean = false;
	signupMsg: string = '';
	doneSignup: boolean = false;
	alreadySignup: boolean = false;
	currentStep: number = 5;
	usernameTaken: boolean = false;

	steps = [
		{ name: "name" },
		{ name: "username" },
		{ name: "password" },
		{ name: "dob" },
		{ name: "connection" },
		{ name: "final" }
	];

	frmSignup: {
		firstName: string,
		firstNameStatus?: boolean,
		lastName: string,
		lastNameStatus?: boolean,
		nameMsg: string,
		byEmail: boolean,
		email: string,
		emailStatus?: boolean,
		username: string,
		usernameStatus?: boolean,
		usernameMsg: string,
		pw1: string,
		pw1Status?: boolean,
		pw2: string,
		pw2Status?: boolean,
		pwMsg: string,
		dobMonth: string,
		dobMonthStatus?: boolean,
		dobDate: string,
		dobDateStatus?: boolean,
		dobYear: string,
		dobYearStatus?: boolean,
		dob: string,
		dobStatus?: boolean,
		dobAge: number,
		dobAgree: false,
		dobMsg: string,
		connectionSkip: boolean,
		connection: string,
		connectionStatus?: boolean,
		connectionMsg: string,
		role: string
	} = {
		firstName: '',
		firstNameStatus: null,
		lastName: '',
		lastNameStatus: null,
		nameMsg: '',
		byEmail: true,
		email: '',
		emailStatus: null,
		username: '',
		usernameStatus: null,
		usernameMsg: '',
		pw1: '',
		pw1Status: null,
		pw2: '',
		pw2Status: null,
		pwMsg: '',
		dobMonth: '',
		dobMonthStatus: null,
		dobDate: '',
		dobDateStatus: null,
		dobYear: '',
		dobYearStatus: null,
		dob: '',
		dobStatus: null,
		dobAge: 100,
		dobAgree: false,
		dobMsg: '',
		connectionSkip: true,
		connection: '',
		connectionStatus: null,
		connectionMsg: '',
		role: 'other'
	};

	@ViewChild('txtFirstName') txtFirstName: ElementRef<HTMLInputElement>;
	@ViewChild('btnUsername') btnUsername: ElementRef<HTMLButtonElement>;
	@ViewChild('txtEmail') txtEmail: ElementRef<HTMLInputElement>;
	@ViewChild('txtUsername') txtUsername: ElementRef<HTMLInputElement>;
	@ViewChild('txtPw1') txtPw1: ElementRef<HTMLInputElement>;
	@ViewChild('txtPw2') txtPw2: ElementRef<HTMLInputElement>;
	@ViewChild('txtDobMonth') txtDobMonth: ElementRef<HTMLInputElement>;
	@ViewChild('txtDobDate') txtDobDate: ElementRef<HTMLInputElement>;
	@ViewChild('txtDobYear') txtDobYear: ElementRef<HTMLInputElement>;
	@ViewChild('txtConnection') txtConnection: ElementRef<HTMLInputElement>;
	@ViewChild('btnPwNext') btnPwNext: ElementRef<HTMLButtonElement>;

	showMinimize = AppSettingService.widgetMobile();

	@HostListener('window:resize', ['$event']) onResize(e: Event) {
		this.showMinimize = AppSettingService.widgetMobile();
	}

	private changeStep(toStep:number) {
		if (toStep > this.currentStep) {
			if (this.currentStep - 1 === this.iStepHighestReached) {
				this.iStepHighestReached++;
			}
		}
		this.currentStep = toStep
		switch (this.currentStep) {
			case 0:
				setTimeout(() => { this.txtFirstName.nativeElement.focus(); }, 250);
				break;
			case 1:
				setTimeout(() => {
					if (this.anonymousUserLink !== '') {
						this.btnUsername.nativeElement.focus();
					}
					else if (this.frmSignup.byEmail) {
						this.txtEmail.nativeElement.focus();
					}
					else {
						this.txtUsername.nativeElement.focus();
					}
				}, 250);
				break;
			case 2:
				setTimeout(() => { this.txtPw1.nativeElement.focus(); }, 250);
				break;
			case 3:
				setTimeout(() => { this.txtDobMonth.nativeElement.focus(); }, 250);
				break;
			case 4:
				setTimeout(() => { this.txtConnection.nativeElement.focus(); }, 250);
				break;
			case 5:
				//final, do nothing
				break;
			default:
				this.currentStep = 0;
				setTimeout(() => { this.txtFirstName.nativeElement.focus(); }, 250);
				break;
		}
	}

	prgIndicatorJumpTo(e: any, toStep: number) {
		switch (this.currentStep) {
			case 0:
				this.checkName(e, toStep);
				break;
			case 1:
				this.checkUsername(e, toStep);
				break;
			case 2:
				this.checkPassword(e, toStep);
				break;
			case 3:
				this.checkDOB(e, toStep);
				break;
			case 4:
				if (!this.frmSignup.connectionSkip) {
					this.checkConnection(e, toStep);
				}
				else {
					this.changeStep(toStep);
				}
				break;
		}
	}

	//#region name
	checkName(e: any, nextStep?: number) {
		if (e.type === 'keyup' && e.keyCode === 9) {
			return;
		}
		this.frmSignup.firstName = this.frmSignup.firstName.trim();
		this.frmSignup.lastName = this.frmSignup.lastName.trim();

		if (e.type === 'focus' || (e.type === 'keyDown' && e.keyCode !== 9 && e.keyCode !== 13 && e.keyCode !== undefined)) {
			if (e.currentTarget.id === 'txtFirstName' && this.frmSignup.firstNameStatus !== null) {
				this.frmSignup.firstNameStatus = null;
				this.frmSignup.nameMsg = "";
				return;
			}
			if (e.currentTarget.id === 'txtLastName' && this.frmSignup.lastNameStatus !== null) {
				this.frmSignup.lastNameStatus = null;
				this.frmSignup.nameMsg = "";
				return;
			}
		}

		//only do validations if enter, tab, or next button
		if (e.keyCode === 13 || nextStep != null || e.keyCode === 9 && e.type !== focus) {
			if ((e.keyCode === 13) || nextStep != null || (e.keyCode === 9 && e.currentTarget.id === 'txtFirstName')) {
				this.frmSignup.firstNameStatus = this.frmSignup.firstName.length < this.nameMinLen ? false : true;
				if (e.keyCode === 13 && this.frmSignup.firstNameStatus) {
					e.currentTarget.blur();
				}
			}
			if ((e.keyCode === 13 && e.currentTarget.id === 'txtLastName') || nextStep != null || (e.keyCode === 9 && e.currentTarget.id === 'txtLastName')) {
				this.frmSignup.lastNameStatus = this.frmSignup.lastName.length < this.nameMinLen ? false : true;
				if (e.keyCode === 13 && this.frmSignup.lastNameStatus) {
					e.currentTarget.blur();
				}
			}

			if (this.frmSignup.firstNameStatus === false || this.frmSignup.lastNameStatus === false) {
				this.frmSignup.nameMsg = "Oops! The minimum length is " + this.nameMinLen + " characters.";
			}
			else {
				if ((e.keyCode === 13 && e.currentTarget.id === 'txtLastName') || nextStep != null) {
					if (this.frmSignup.firstNameStatus && this.frmSignup.lastNameStatus) {
						this.changeStep(nextStep == null ? this.currentStep + 1 : nextStep);
					}
				}
			}
		}
		else {
			if (e.keyCode !== 9 && e.keyCode !== undefined) {
				this.frmSignup.nameMsg = "";
			}
		}
	}
	//#endregion name

	//#region username
	toggleUsernameEmail() {
		this.frmSignup.byEmail = !this.frmSignup.byEmail;
		if (this.frmSignup.byEmail) {
			this.frmSignup.username = '';
			this.frmSignup.usernameStatus = null;
		}
		else {
			this.frmSignup.email = '';
			this.frmSignup.emailStatus = null;
		}
	}

	checkUsername(e: any, nextStep?:number) {
		if (e.keyCode !== 9 && e.type === 'keydown') {
			return;
		}

		this.frmSignup.emailStatus = null;
		this.frmSignup.usernameStatus = null;
		this.frmSignup.email = this.frmSignup.email.trim();
		this.frmSignup.username = this.frmSignup.username.trim();
		let loginName = this.frmSignup.byEmail ? this.frmSignup.email : this.frmSignup.username;

		if (e.keyCode === 13 || nextStep != null || e.keyCode === 9) {
			if (this.frmSignup.byEmail) {
				this.frmSignup.usernameStatus = null;
				if (loginName.length < this.usernameMinLen || !AppUtilityService.isEmail(loginName)) {
					this.frmSignup.emailStatus = false;
				}
				else {
					this.frmSignup.emailStatus = true;
				}
			}
			else {
				this.frmSignup.emailStatus = null;
				if (loginName.length < this.usernameMinLen) {
					this.frmSignup.usernameStatus = false;
				}
				else {
					this.frmSignup.usernameStatus = true;
				}
			}

			if (this.frmSignup.emailStatus === false || this.frmSignup.usernameStatus === false) {
				this.frmSignup.usernameMsg = this.frmSignup.byEmail ? 'Oops! Something is funky. Please enter a valid email address.' : 'Oops! Please enter a valid username.';
			}
			else {
				//username is unique per zone. Zone is unknown until users decide having access code or not. 
				// so no point to check username here
				if (e.keyCode !== 9) {
					this.changeStep(nextStep == null ? this.currentStep + 1 : nextStep);
				}
			}
		}
		else {
			this.frmSignup.usernameMsg = "";
		}
	}
	//#endregion username

	//#region password
	txtPw1Type: string = 'password';
	txtPw2Type: string = 'password';
	showPassword(id: string) {		
		var input = this.doc.getElementById(id);
		if (input != null) {
			input.type = (input.type === 'password') ? 'text' : 'password';
			if (id === 'txtPw1') {
				this.txtPw1Type = input.type;
			}
			if (id === 'txtPw2') {
				this.txtPw2Type = input.type;
			}
		}
	}

	pw1isFocused: boolean = false;
	checkPassword(e: any, nextStep?: number) {
		if (e != null && e.currentTarget != null && e.currentTarget.value != null) {
			e.currentTarget.value = e.currentTarget.value.trim();
		}

		if (e.type === 'blur' && e.target.id === 'txtPw1') {
			this.pw1isFocused = false;
		}

		if (e.type === 'focus') {
			if (e.target.id === 'txtPw1') {
				this.pw1isFocused = true;
			} else {
				this.pw1isFocused = false;
			}
			
			if (this.frmSignup.pw1Status === false) {
				this.frmSignup.pw1Status = null;
			}
			if (this.frmSignup.pw2Status === false) {
				this.frmSignup.pw2Status = null;
			}
			this.frmSignup.pwMsg = "";
			return;
		}

		if (e.type === 'keyup' && e.keyCode !== 9 && e.keyCode !== 13) {
			if (e.target.id === 'txtPw1') {
				this.frmSignup.pw1Status = null;
			}
			if (e.target.id === 'txtPw2') {
				this.frmSignup.pw2Status = null;
			}
			return;
		}

		if ((e.currentTarget.id === 'txtPw1' && (e.keyCode === 9 || e.keyCode === 13)) || nextStep != null) {
			if (this.frmSignup.pw2Status === false) {
				this.frmSignup.pw2Status === null;
			}
			var pw = AppUtilityService.validatePassword(this.txtPw1.nativeElement.value);
			this.frmSignup.pw1Status = pw.strength < 100 ? false : true;

			if (this.frmSignup.pw1Status === true) {
				this.frmSignup.pwMsg ="";
				if (nextStep == null) {
					setTimeout(() => { this.txtPw2.nativeElement.focus(); }, 100);
				}
			} else {
				this.frmSignup.pw1Status = false;
				this.txtPw1.nativeElement.blur();
				this.frmSignup.pwMsg = pw.message;
			}
		}

		if ((e.currentTarget.id === 'txtPw2' && (e.keyCode === 13 || e.keyCode === 9)) || nextStep != null) {
			//bc some sort of timing thing happens that sends us back in here on keyup after tabbing or entering out of pw1 field
			if (e.type === 'keyup') {
				return;
			}

			if (this.frmSignup.pw1Status === false) {
				this.frmSignup.pw1Status === null;
			}
			let pw = AppUtilityService.validatePassword(this.txtPw2.nativeElement.value);
			this.frmSignup.pw2Status = pw.strength < 100 ? false : true;

			if (this.frmSignup.pw2Status === true) {
				this.frmSignup.pwMsg = "";
				if (this.frmSignup.pw1 === this.frmSignup.pw2) {
					this.frmSignup.pw1Status === true;
					this.frmSignup.pw2Status === true;
					this.frmSignup.pwMsg = "";
					//only go to next screen if user hit enter or next button (tab should just provide validation feedback)
					if (e.keyCode === 13 || nextStep != null) {
						this.changeStep(nextStep == null ? this.currentStep + 1 : nextStep);
					} else {
						if (e.keyCode === 9) {
							setTimeout(() => {this.btnPwNext.nativeElement.focus();}, 100);
						}
					}
				} else {
					this.frmSignup.pw1Status = false;
					this.frmSignup.pw2Status = false;
					this.txtPw2.nativeElement.blur();
					this.frmSignup.pwMsg = 'Oops! Please make sure both passwords are the same.';
					if (e.keyCode === 9) {
						setTimeout(() => {this.btnPwNext.nativeElement.focus();}, 100);
					}
				}
			}
			else {
				this.frmSignup.pw2Status = false;
				this.txtPw2.nativeElement.blur();
				this.frmSignup.pwMsg = pw.message;
			}
		}
	}
	//#endregion password

	//#region dob
	dobMonthDisplay:string = '';
	dobDateDisplay: string = '';
	dobYearDisplay: string = '';
	private valMonth() {
		if (this.dobMonthDisplay.length >= 1 && this.dobMonthDisplay.length <= 2) {
			this.frmSignup.dobMonthStatus = (parseInt(this.dobMonthDisplay) < 1 || parseInt(this.dobMonthDisplay) > 12) ? false : true;
		} else {
			this.frmSignup.dobMonthStatus = false;
		}
	}

	private valDate() {
		this.frmSignup.dobDateStatus = ((this.dobDateDisplay.length > 2 || this.dobDateDisplay.length === 0) || parseInt(this.dobDateDisplay) < 1 || parseInt(this.dobDateDisplay) > 31) ? false : true;
	}

	private valYear() {
		this.frmSignup.dobYearStatus = (this.dobYearDisplay.length !== 4 || parseInt(this.dobYearDisplay) < this.minYear || parseInt(this.dobYearDisplay) > this.maxYear) ? false : true;
	}

	checkDOB(e: any, nextStep?:number) {
		//trim out not number
		this.dobMonthDisplay = this.dobMonthDisplay.replace(/\D/g, '').trim();
		this.dobDateDisplay = this.dobDateDisplay.replace(/\D/g, '').trim();
		this.dobYearDisplay = this.dobYearDisplay.replace(/\D/g, '').trim();

		//month status
		if (e.keyCode === 13 || e.currentTarget.id === 'txtDobMonth') {
			this.valMonth();
		}
		//auto forward on 2 digit input
		if (this.frmSignup.dobMonthStatus && e.keyCode != null && e.keyCode !== 9 && e.keyCode !== 8) {
			if (e.target.id === 'txtDobMonth' && e.currentTarget.value.length === 2) {
				this.txtDobDate.nativeElement.focus();
				return;
			}
		}
		//date status
		if (e.keyCode === 13 || e.currentTarget.id === 'txtDobDate') {
			this.valDate();
		}
		//auto forward on 2 digit input
		if (this.frmSignup.dobDateStatus && e.keyCode != null && e.keyCode !== 9 && e.keyCode !== 8) {
			if (e.target.id === 'txtDobDate' && e.currentTarget.value.length === 2) {
				this.txtDobYear.nativeElement.focus();
				return;
			}
		}
		//year status 
		if (e.keyCode === 13 || e.currentTarget.id === 'txtDobYear') {
			this.valYear();
		}
		if (e.keyCode === 13 || nextStep != null || (e.type === 'keyup' && this.dobMonthDisplay !== '' && this.dobDateDisplay !== '' && this.dobYearDisplay !== '')) {
			//re-validate fields incase user left fields populated without tabbing or entering out of them after editing dob
			this.valMonth();
			this.valDate();
			this.valYear();

			//format saved date as double date 
			if (this.dobMonthDisplay.length === 1) {
				this.frmSignup.dobMonth = '0' + this.dobMonthDisplay;
			} else {
				this.frmSignup.dobMonth = this.dobMonthDisplay;
			}
			if (this.dobDateDisplay.length === 1) {
				this.frmSignup.dobDate = '0' + this.dobDateDisplay;
			} else {
				this.frmSignup.dobDate = this.dobDateDisplay;
			}

			if (this.dobYearDisplay.length === 1) {
				this.frmSignup.dobYear = '0' + this.dobYearDisplay;
			} else {
				this.frmSignup.dobYear = this.dobYearDisplay;
			}
			// check if it is a valid date
			if (this.frmSignup.dobMonthStatus === true && this.frmSignup.dobDateStatus === true && this.frmSignup.dobYearStatus === true && this.dobSrv.validateDate(this.frmSignup.dobMonth, this.frmSignup.dobDate, this.frmSignup.dobYear)) {
				this.frmSignup.dob = this.dobSrv.Dob;
				this.frmSignup.dobAge = this.dobSrv.Age;
				this.frmSignup.dobStatus = true;
				if (((e.keyCode === 13 || e.type === 'click') && this.frmSignup.dobAge >= 13) || (e != null && e.type === 'click' && e.currentTarget.id === 'btnGotPermission')) {
					this.frmSignup.dobMsg = "";
					this.changeStep(nextStep == null ? this.currentStep + 1 : nextStep);
				} else if (this.frmSignup.dobAge < 13) {
					this.frmSignup.dobMsg = 'Looks like you\'re younger than 13. Get your guardian\'s permission before moving ahead!';
				}
				else {
					this.frmSignup.dobMsg = "";
				}
			}
			else {
				this.frmSignup.dobMsg = 'Please check that date is formatted as MM-DD-YYYY';
				this.frmSignup.dobStatus = false;
			}
		}

		//if user hit enter or next we should blur from all fields
		if (e.keyCode === 13) {
			this.txtDobMonth.nativeElement.blur();
			this.txtDobDate.nativeElement.blur();
			this.txtDobYear.nativeElement.blur();
		}
	}
	//#endregion dob

	//#region connection
	toggleConnect(hasCode:boolean) {
		this.frmSignup.connectionSkip = !hasCode;
		if (!hasCode) {
			this.frmSignup.connection = '';
			this.frmSignup.connectionStatus = true;
			this.frmSignup.role = 'Other';
			this.submitSignup();
		}
		else {
			this.frmSignup.connectionStatus = null;
		}
	}

	private checkCode() {
		this.frmSignup.connectionStatus = false;
		//validate connection code
		this.userAPI.checkValidationCodeExist(this.frmSignup.connection).subscribe({
			next: (response: any) => {
				if (response.Detail === 'true') {
					this.frmSignup.role = response.Note;
					this.frmSignup.connectionStatus = true;
					this.submitSignup();
				} else {
					this.frmSignup.connectionMsg = 'Hmmm we don\'t recognize your code, please try again. Please contact <a href="mailto:help@journeysmap.com">help@journeysmap.com</a>.';
					this.frmSignup.connectionStatus = false;
				}
			},
			error: (err: any) => {
				let error = err.error;
				if (error && error.Detail) {
					if (error.Detail.toLowerCase() === 'expired') {
						this.frmSignup.connectionMsg = 'Hmmm this code has expired, please verify the code and try again or contact your teacher.';
					}
					else {
						this.frmSignup.connectionMsg = 'Hmmm we don\'t recognize your code, please try again. Please contact <a href="mailto:help@journeysmap.com">help@journeysmap.com</a>.';
					}
				}
				else {
					this.frmSignup.connectionMsg = 'Oops! Something went wrong. Please try again later.';
				}
				this.frmSignup.connectionStatus = false;
			}
		});
	}

	checkConnection(e: any, nextStep?:number) {
		this.frmSignup.connectionMsg = "";
		if (e.keyCode === 13 || nextStep != null) {
			this.checkCode();
		}
		if (e.keyCode === 9) {
			this.checkCode();
		}
		if (this.frmSignup.connectionStatus === false) {
			this.frmSignup.connectionStatus = null;
		}
	}
	//#endregion connection

	private signupErrorCode = '';
	reviewRetry() {
		if (this.signupErrorCode === '50004') {
			this.changeStep(1);
		}
		else {
			this.changeStep(0);
		}
	}

	private submitSignup() {
		this.currentStep = this.steps.length - 1;
		this.signupErrorCode = '';
		this.doneSignup = false;
		this.isWaiting = true;
		this.usernameTaken = false;

		let username = this.anonymousUser != null ? this.anonymousUser.Email : this.frmSignup.byEmail ? this.frmSignup.email.trim() : this.frmSignup.username.trim();
		// if username is like email, copy it to email field
		let email = AppUtilityService.isEmail(username) ? username : '';

		let institutionCode = '';
		if (this.institution != null && this.isPublic === true) {
			institutionCode = this.institution.InstitutionCode;
		}

		let apiKey = this.anonymousUser != null ? this.anonymousUser.APIKey : this.userInfo.getProfile().APIKey.trim();

		let reg = {
			BirthDate: this.frmSignup.dob,
			Email: email,
			FirstName: this.frmSignup.firstName.trim(),
			LastName: this.frmSignup.lastName.trim(),
			Password: this.frmSignup.pw1,
			PersonRoles: [{ Role: this.frmSignup.role }],
			UserName: username,
			ValidationCode: this.frmSignup.connection.trim(),
			InstitutionCode: this.anonymousUser != null ? this.anonymousUser.InstitutionCode : institutionCode.trim(),
			APIKey: apiKey,
			AnonymousUserLink: this.anonymousUser != null ? this.anonymousUser.AnonymousUserLink : ''
		};

		this.signupMsg = 'Submit sign up info ...';
		let sessionId: string = "";
		this.sessionAPI.getSessionId().subscribe({
			next: (response: any) => {
				sessionId = response;
				this.userAPI.register(reg).subscribe({
					next: (success: any) => {
						if (success !== null && success.UserName !== null && success.Password !== null) {
							this.signupMsg = 'Login...';
							// try to login with new user/pw
							this.sessionAPI.signOn(success.UserName, success.Password, success.ZoneClient).subscribe({
								next: () => {
									this.doneSignup = true;
									if (reg.AnonymousUserLink.length > 0) {
										this.signupMsg = 'Transfer anonymous user by email...';
										this.userAPI.transferAnonymousUserData(this.anonymousUser.AnonymousUserLink).subscribe({
											next: () => {
												this.closeSignup();
											},
											error: (error: any) => {
												console.log(error);
												this.closeSignup();
											}
										});
									}
									else if (sessionId.length > 0) {
										this.signupMsg = 'Transfer anonymous session data...';
										this.userAPI.copyAnonymousSessionData(sessionId).subscribe({
											next: () => {
												this.closeSignup();
											},
											error: (error: any) => {
												console.log(error);
												this.closeSignup();
											}
										});
									}

									else {
										this.closeSignup();
									}
								},
								error: (error: any) => {
									console.log(error);
									error = error.error;
									this.signupMsg = error.Detail != null ? error.Detail : "";
									this.isWaiting = false;
								}
							});
						}
						else {
							this.signupMsg = 'Fail to login automatically. Please try to login manually.';
							this.isWaiting = false;
						}
					},
					error: (error: any) => {
						console.log(error);
						error = error.error;
						this.signupErrorCode = (error.Code ?? "");
						if (error.Code === '50004') {
							this.usernameTaken = true;
						}
						else {
							this.signupMsg = error.Detail;
						}
						this.isWaiting = false;
					}
				});
			},
			error: (err: any) => {
				console.log(err);
				this.signupMsg = 'Fail to sign up. Please retry.';
				this.isWaiting = false;
			}
		})
			
	}

	private closeSignup() {
		this.onClose('signup');
	}

	goLogin() {
		this.onClose('showLogin');
	}

	cancel(e: any) {
		this.onClose('cancel');
	}

	login(e: any) : void {
		e.preventDefault();
		this.onClose('showLogin');
	}

	private getInstitution() {
		// see if this user is from NCES, Cyber... learn more
		if (this.userInfo.getInstitutionCode() !== '') {
			this.institutionAPI.getInstitution(this.userInfo.getInstitutionCode()).subscribe({
				next: (result: any) => {
					if (result) {
						this.institution = result;
					}
					this.isWaiting = false;
				},
				error: (error: any) => {
					console.log(error);
					this.isWaiting = false;
				}
			});
		}
		else {
			this.isWaiting = false;
		}

		// go to first step
		this.currentStep = 0;
		setTimeout(() =>{this.txtFirstName.nativeElement.focus();}, 1000);
	}

	ngAfterViewInit(): void {
		// get anonymous user info if anonymousUserLink is provided
		this.anonymousUser = null;
		if (this.anonymousUserLink === '') {
			this.getInstitution();
		}
		else {
			this.userAPI.getAnonymousUser(this.anonymousUserLink).subscribe({
				next: (response: any) => {
					if (response.Email !== '') {
						this.anonymousUser = response;
						this.frmSignup.byEmail = true;
						this.frmSignup.email = this.anonymousUser.Email;
						this.frmSignup.emailStatus = true;
						this.frmSignup.username = '';
						this.frmSignup.usernameStatus = null;
						// already sign up?
						if (this.anonymousUser.SignUpTime != null && this.anonymousUser.SignUpTime !== '') {
							this.alreadySignup = true;
							this.isWaiting = false;
							return;
						}
					}
					else {
						this.anonymousUserLink = '';
					}
					this.getInstitution();
				},
				error: () => {
					this.anonymousUserLink = '';
					this.getInstitution();
				}
			});
		}
	}

	ngOnInit(): void {
		this.anonymousUserLink = (this.anonymousUserLink??"").trim();
		this.isWaiting = true;
		this.signupMsg = '';
		this.doneSignup = false;
		this.alreadySignup = false;
		this.currentStep = this.steps.length - 1;

		// if user already login and somehow this is called, then do not show signup, show login instead
		if (this.userInfo.isAnonymous() === false || !this.userInfo.allowSignup()) {
			this.onClose('showSignup');
			return;
		}
	}
}
